import update from 'immutability-helper'

const defaultState = {
  isAdding: false,
  error: undefined
}
export default function reducer (state = defaultState, action = {}) {
  switch (action.type) {
    case 'START_ADDING':
      return update(state, { $set: { isAdding: true } })
    case 'SUCCEEDED_ADDING':
      return update(state, { $set: { isAdding: false } })
    case 'FAILED_ADDING':
      return update(state, {
        $set: { isAdding: false, error: action.payload },
        $unset: ['error']
      })
    default:
      return state
  }
}

export const addCustomer = customer => async (
  dispatch,
  getState,
  getFirebase
) => {
  dispatch({ type: 'START_ADDING' })
  const firebase = getFirebase()
  try {
    await firebase.push('customers', customer)
    dispatch({ type: 'SUCCEEDED_ADDING' })
  } catch (error) {
    dispatch({ type: 'FAILED_ADDING', payload: error })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/customers.js